import React, { Component } from "react";
import "./App.css";
import { Switch, withRouter } from "react-router-dom";
import Header from "./components/Header";
import SideBar from "./components/SideBar";
import Admins from "./components/Admins";
import Admin from "./components/Admin";
import Member from "./components/Member";
import Search from "./components/Search";
import SignIn from "./components/Signin";
import Pledges from "./components/Pledges";
import PledgeForm from "./components/PledgeForm";
import { connect } from "react-redux";
import Authenticated from "./components/Authenticated";
import Public from "./components/Public";
import Reports from "./components/Reports";
import EventsPreachersTab from "./components/EventsPreachersTab";
import NoticesTab from "./components/NoticesTab";
import PrayerAndMeditationTab from "./components/PrayerAndMeditationTab";
import MainPane from "./components/MainPane";
import Dashboard from "./components/Dashboard";
import AssetsManager from "./components/AssetsManager";
const Home = props => {
  return <div />;
};

class App extends Component {
  render() {
    let { appProps } = this.props;
    return (
      <div className="App">
        <Header {...appProps} />
        <SideBar {...appProps} />
        <Switch>
          <MainPane {...appProps}>
            <Authenticated exact path="/" {...appProps} component={Home} />
            <Authenticated
              exact
              path="/dashboard"
              {...appProps}
              component={Dashboard}
            />
            <Authenticated
              exact
              path="/search"
              {...appProps}
              component={Search}
            />
            <Authenticated
              exact={true}
              path="/members"
              component={Search}
              {...appProps}
            />
            <Authenticated
              exact
              path="/members/new"
              component={Member}
              {...appProps}
            />
            <Authenticated
              exact
              path="/members/:id/edit/"
              component={Member}
              {...appProps}
            />
            <Authenticated
              exact
              path="/pledges"
              component={Pledges}
              {...appProps}
            />
            <Authenticated
              exact
              path="/pledges/new"
              component={PledgeForm}
              {...appProps}
            />
            <Authenticated
              exact
              path="/reports"
              component={Reports}
              {...appProps}
            />
            <Authenticated
              exact
              path="/admins"
              component={Admins}
              {...appProps}
            />
            <Authenticated
              exact
              path="/admins/new"
              component={Admin}
              {...appProps}
            />
            <Authenticated
              exact
              path="/admins/:id/password/"
              component={Admin}
              {...appProps}
            />
            <Authenticated
              exact
              path="/admins/:id/edit/"
              component={Admin}
              {...appProps}
            />
            <Authenticated
              exact
              path="/events"
              component={EventsPreachersTab}
              {...appProps}
            />
            <Authenticated
              exact
              path="/notices"
              component={NoticesTab}
              {...appProps}
            />
            <Authenticated
              exact
              path="/prayers"
              component={PrayerAndMeditationTab}
              {...appProps}
            />
            <Authenticated
              exact
              path="/assets"
              component={AssetsManager}
              {...appProps}
            />
            <Public exact path="/signin" component={SignIn} {...appProps} />
          </MainPane>
        </Switch>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    appProps: state.app
  };
};
export default withRouter(connect(mapStateToProps)(App));



// WEBPACK FOOTER //
// ./src/App.js